import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';

//Import Icons
import FeatherIcon from 'feather-icons-react';

import tvinsurelogo from '../../shared/images/TV-Insure-Logo-04.png';
import tvinsureregisbg from '../../shared/images/TVinsure-Contact-Me.png';
import './PageAuth.css';

const PageSignup = () => {
    return (
        <React.Fragment>
            <section
                className="bg-home d-flex align-items-center bg-color bg-auth"
            >

                <Container>
                    <Row className="justify-content-center">
                        <Col lg={12} className="mt-0">
                            <div className="d-block text-center my-3">
                                <span>
                                    <img src={tvinsurelogo} alt="TVinsure" height="80" />
                                    <h3 className="text-center mt-2">สมัครสมาชิกผู้แนะนำ</h3>
                                </span>
                            </div>
                        </Col>
                        <Col lg={5} className="mt-5">
                            <Card className="shadow-lg">
                                <CardBody>
                                    <div className="text-center my-3">
                                        <i><FeatherIcon icon="user-check" size={100} strokeWidth={1.5} /></i>
                                    </div>
                                    <h4 className="text-center">ลงทะเบียนสมาชิกเดิม</h4>
                                    <h6 className="text-center">(สำหรับผู้ที่มีรหัสผู้แนะนำอยู่แล้ว)</h6>
                                    <p className="text-center">เพื่อสมัครใช้ระบบ <a href="https://info.tvinsure.com/app-info" className="text-warning">TVinsure Web App</a></p>
                                    <Col lg={12} className="mb-0 auth-button mt-4">
                                        <Link to="/signup-with-code" className="text-light">
                                            <Button color="warning" block>ลงทะเบียนสมาชิกเดิม</Button>
                                        </Link>
                                    </Col>
                                    <Col xs={12} className="text-center">
                                        <p className="mb-0 mt-3"><small className="text-dark mr-2 h6 mt-2">มีบัญชีอยู่แล้ว ?</small><Button onClick={() => {
                                            const check = window.confirm("ยืนยันการเข้าสู่หน้า Log In")
                                            if (check === true) {
                                                window.location.href = "https://webapp.tvinsure.com/dashboard";
                                            } else {
                                                return false
                                            }
                                        }} className="font-weight-bold h5 text-warning" outline color="warning">เข้าสู่ระบบ</Button></p>
                                    </Col>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={5} className="mt-5">
                            <Card>
                                <CardBody>
                                    {/* <div className="text-center mb-3">
                                        <span>
                                            <img src={tvinsurelogo} alt="TVinsure" height="60" />
                                        </span>
                                    </div> */}
                                    <div className="text-center my-3">
                                        <i><FeatherIcon icon="user-plus" size={100} strokeWidth={1.5} /></i>
                                    </div>
                                    <h4 className="text-center">ลงทะเบียนสมาชิกใหม่</h4>
                                    <h6 className="text-center">(ไม่เคยมีรหัสผู้แนะนำ)</h6>
                                    <p className="text-center">เพื่อเปิดรหัสผู้แนะนำและสมัครใช้ระบบ <a href="https://info.tvinsure.com/app-info" className="text-warning">TVinsure Web App</a></p>
                                    <Col lg={12} className="mb-0 auth-button mt-4">
                                        <Link to="/signup-without-code" className="text-light">
                                            <Button color="warning" block>ลงทะเบียนสมาชิกใหม่</Button>
                                        </Link>
                                    </Col>
                                    <Col xs={12} className="text-center">
                                        <p className="mb-0 mt-3"><small className="text-dark mr-2 h6 mt-2">มีบัญชีอยู่แล้ว ?</small><Button onClick={() => {
                                            const check = window.confirm("ยืนยันการเข้าสู่หน้า Log In")
                                            if (check === true) {
                                                window.location.href = "https://webapp.tvinsure.com/dashboard";
                                            } else {
                                                return false
                                            }
                                        }} className="font-weight-bold h5 text-warning" outline color="warning">เข้าสู่ระบบ</Button></p>
                                    </Col>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}


export default PageSignup;